// Copyright (C) 2019 TANNER AG

import gql from "graphql-tag";

export default gql`
    query translations($language: String = "de") {
        tcoTranslations(language: $language) {
            slug
            translation
        }
    }
`;



// WEBPACK FOOTER //
// ./src/tco/queries/translations.js